import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class LocaleService {
    private clock: string = "";
    private _clockSource = new BehaviorSubject<string>("");
    public clock$ = this._clockSource.asObservable();

    currency_props = {
	style: "currency",
	currency: "EUR"
    };

    date_props = {
	year: "numeric",
	month: "2-digit",
	day: "2-digit"
    };

    date_time_props = {
	year: "numeric",
	month: "2-digit",
	day: "2-digit",
	hour: "2-digit",
	minute: "2-digit",
	second: "2-digit"
    };

    constructor() {
	setInterval(() => {this.setClock();}, 1000);
    }

    setClock(){
	let d = new Date();
	let mese = d.getMonth() + 1
	let data = this.twoDigits(d.getDate())+"/"+this.twoDigits(mese)+"/"+d.getFullYear();
	let ora = this.twoDigits(d.getHours())+":"+this.twoDigits(d.getMinutes())+":"+this.twoDigits(d.getSeconds());
	this.clock = data+" "+ora;

	this._clockSource.next(this.clock);
    }

    getSaluto(){
	let saluto = "Salve";
	let d = new Date();
	let ore = d.getHours();
	if(ore >= 12 && ore <= 18){
	    saluto = "Buon pomeriggio";
	}
	if(ore >= 19 && ore <= 21){
	    saluto = "Buona sera";
	}
	if(ore >= 22 && ore <= 6){
	    saluto = "Buona notte";
	}
	if(ore >= 6 && ore <= 12){
	    saluto = "Buon giorno";
	}
	if(ore == 0){
	    saluto = "Buona notte";
	}
	return saluto;
    }

    twoDigits(digit: number) {
	if(0 <= digit && digit < 10)
	    return "0" + digit.toString();
	if(-10 < digit && digit < 0)
	    return "-0" + (-1*digit).toString();
	return digit.toString();
    }

    twoDigitsDecimal(value: any) {
	value = String(value);
	value = parseFloat(value).toFixed(2);
	return value;
    }

    addDate(partenza_date: Date, tipo: string, numero: number) {
	let finale_date = partenza_date;
	let finale_string = "";
	if(tipo == 'days') {
	    finale_date.setDate(partenza_date.getDate() + numero);
	}
	finale_string = finale_date.toLocaleDateString();
	//console.log("add", finale_string);
	return finale_string;
    }

    toLocaleNumber(param: string) {
	if(typeof(param) == 'string'){
	    param = param.replace(/€/gi, '');
	    param = param.replace(/\s+/g, '');
	    param = this.replaceLast(param, '.', '#');
	    param = param.replace(/\./gi, '');
	    param = param.replace(/,/gi, '#');
	    param = this.replaceLast(param, '#', '@');
	    param = param.replace(/\#/gi, '')
	    param = param.replace(/\@/gi, '.');
	}
	let result = this.toNumber(param);
	//console.log("toLocaleNumber ", param, "'",  result, "'");
	return result;
    }

    toNumber(param: string) {
	//console.log("toNumber", param, Number(param));
	return Number(param);
    }

    toCurrency(param: string) {
	return Number(param).toLocaleString("it-IT", this.currency_props);
    }

    toDate(param: string = null){
	if(param){
	    return new Date(param).toLocaleDateString();
	}
	return null;
    }

    toInternetString(param: string = null) {
	let parts: any = [];
	let anno: number;
	let mese: number;
	let giorno: number;
	if(param){
	    parts = param.split('/');
	    //console.log("SRV|LOCALE - internetString", parts[0], parts[1], parts[2]);
	    anno = Number(parts[2]);
	    mese = Number(parts[1]);
	    giorno = Number(parts[0]);
	    return this.twoDigits(anno) + "-" + this.twoDigits(mese) + "-" + this.twoDigits(giorno);
	}
	else
	    return null;
    }

    toInternetDate(param: string = null) {
	let parts: any = [];
	if(param){
	    parts = param.split('/');
	    //console.log("SRV|LOCALE - internetDate", parts[0], parts[1], parts[2]);
	    return new Date(parts[2], parts[1] - 1, parts[0]);
	}
	else
	    return new Date(Date.now());
    }

    toLocaleDate(param: string){
	if(param){
	    let dateTemp = new Date(param);
	    if(dateTemp instanceof Date && !isNaN(dateTemp.valueOf())){
		return new Date(param).toLocaleDateString("it-IT", this.date_props);
	    }else{
		return param;
	    }
	}
	return "";
    }

    toLocaleDateTime(param: string) {
	if(param){
	    let dateTemp = new Date(param);
	    if(dateTemp instanceof Date && !isNaN(dateTemp.valueOf())){
		return new Date(param).toLocaleDateString("it-IT", this.date_time_props);
	    }else{
		return param;
	    }
	}
	return "";
    }

    capitalizeFirstLetter(inputString: string) {
	return inputString.charAt(0).toUpperCase().concat(inputString.slice(1));
    }

    replaceLast(originalString, find, what){
      var splittedString = originalString.split("");
      splittedString[originalString.lastIndexOf(find)] = what;
      return splittedString.join("");
    }

    nz(value: string, defalutString: string = "0"){
	//console.log("SRV|LOCALE - nz value", value);
	let temp = Number(value);
	//console.log("SRV|LOCALE - nz temp", temp, isNaN(temp));
	if(value === "" || isNaN(temp)){
	    return defalutString;
	}
	return value;
    }
}
